export const useSearch = (list: any[], handleResult: any, filter: number) => {
  const findItems = (query: string) => {
    const search = query.toLowerCase();
    return list.filter((item) =>
      filter >= 0
        ? item[filter].toLowerCase().includes(search)
        : item.join().toLowerCase().includes(search)
    );
  };

  const onInputChange = (event: any) => {
    findItems(event.target.value);
    const res = findItems(event.target.value);
    handleResult(res);
  };

  return {
    onInputChange,
  };
};
